import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import LeagueRank from 'components/league/league_rank';
import NameWithIcons from 'components/user/name_with_icons';
import UserProfileImage from 'components/user/user_profile_image';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.highlighted ? Theme.lightBlue : '#FFF'};
  border: 1px solid ${Theme.lightGray};
  border-radius: 5px;
  padding: 8px;
`;

const TableCell = styled.div`
  font-size: 14px;
  color: ${Theme.darkGray};
`;

const NameCell = styled(TableCell)`
  flex: 1;
  display: flex;
  gap: 5px;
`;

const XpCell = styled(TableCell)`
  text-align: right;
  width: fit-content;
  white-space: nowrap;
  font-weight: bold;
  color: #000;
`;

@observer
class LeagueUserRow extends React.Component {

  @computed get highlighted() {
    return this.props.userId && this.props.userLeague.user.id === this.props.userId;
  }

  render() {
    return (
      <Wrapper
        highlighted={this.highlighted}
      >
        <LeagueRank
          rank={this.props.userLeague.rank}
          promotionStatus={this.props.promotionStatus}
        />
        <NameCell>
          <UserProfileImage
            clickToProfile
            showLanguageIcon={false}
            user={this.props.userLeague.user}
            width={40}
          />
          <NameWithIcons
            user={this.props.userLeague.user}
          />
        </NameCell>
        <XpCell>{this.props.userLeague.xp} XP</XpCell>
      </Wrapper>
    );
  }
}

export default LeagueUserRow;